import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AnalyticLayoutComponent } from './analytic-layout/analytic-layout.component';
import { DealerPayoutAnalyticsComponent } from './dealer-payout-analytics/dealer-payout-analytics.component';

const routes: Routes = [
  {
      path: '', component: AnalyticLayoutComponent,
      children: [
          { path: 'receivable', component: DealerPayoutAnalyticsComponent },
      ]
  }
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnalyticRoutingModule { }
